// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.customer_residency_container {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
    gap: 25px;
    padding: 25px;
    /* background-color: #f9f9f9; */
    border-radius: 12px;
    /* box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1); */
    margin-top: 50px;
}

.customer_residency_name {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    /* background: linear-gradient(145deg, #f6ede7, #ffffff); */
    border: 1px solid #d85200;
    border-radius: 15px;
    box-shadow: 2px 0 25px #d9baa740;
    transition: all 0.3s ease;
    cursor: pointer;
    overflow: hidden;
    height: 100px;
    width: 300px;
}
.customer_residency_name:hover {
  transform: translateY(-8px);
  box-shadow: 6px 6px 12px rgba(0, 0, 0, 0.15),
    -6px -6px 12px rgba(255, 255, 255, 0.9);
  background: linear-gradient(145deg, #f9f9f9, #e9e9e9);
}

.customer_residency_name p {
  margin: 0;
  padding: 16px;
  font-size: 1.1rem;
  font-weight: 700;
  color: #333;
  text-align: center;
  transition: color 0.3s ease;
}

.customer_residency_name:hover p {
    color: #d85200;
}

.customer_residency_name .card-image {
  width: 100%;
  height: 140px;
  background-size: cover;
  background-position: center;
  border-bottom: 1px solid #ddd;
}

@media (max-width: 768px) {
  .customer_residency_name {
    border-radius: 12px;
  }

  .customer_residency_name p {
    font-size: 1rem;
    padding: 14px;
  }

  .customer_residency_name .card-image {
    height: 120px;
  }
}

@media (max-width: 480px) {
  .customer_residency_container {
    gap: 20px;
    padding: 15px;
    grid-template-columns: 1fr 1fr;
  }
  .customer_residency_name .card-image {
    height: 100px;
  }

  .customer_residency_name p {
    font-size: 0.9rem;
  }
}

/* booked cuatomer table */

.booked_customer_main_table_wrapper {
  padding: 20px;
  background-color: #f9f9f9;
  border-radius: 12px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  max-width: 100%;
  margin: 20px auto;
  overflow-x: auto;
}

.booked_customer_data_table_close_button {
  background-color: #f44336;
  color: #fff;
  border: none;
  padding: 10px 20px;
  font-size: 1rem;
  font-weight: bold;
  border-radius: 6px;
  cursor: pointer;
  margin-bottom: 20px;
  transition: background-color 0.3s ease;
}

.booked_customer_data_table_close_button:hover {
  background-color: #d32f2f;
}

.booked_customer_data_table {
  width: 100%;
  border-collapse: collapse;
  background-color: #fff;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.booked_customer_data_table thead {
    background-color: #ffe6d7;
    color: #d85200;
}

.booked_customer_data_table thead th {
  padding: 12px 15px;
  text-align: left;
  font-size: 1rem;
  border: 1px solid #fff;
}

.booked_customer_data_table tbody tr {
  /* border-bottom: 1px solid #ddd; */
  /* border: 1px solid #bbb8b8; */
}

.booked_customer_data_table tbody tr:hover {
  background-color: #f1f1f1;
}

.booked_customer_data_table tbody td {
  padding: 12px 15px;
  font-size: 0.9rem;
  color: #333;
  border: 1px solid #bbb8b8;
}

.booked_customer_data_show_button {
    background-color: #d85200;
    color: #fff;
    border: none;
    padding: 8px 16px;
    font-size: 0.9rem;
    border-radius: 6px;
    cursor: pointer;
    transition: background-color 0.3s ease;
}

.booked_customer_data_show_button:hover {
  background-color: #0056b3;
}

.booked_customer_data_not_found {
  font-size: 1rem;
  color: #666;
  text-align: center;
  margin-top: 20px;
}

@media (max-width: 768px) {
  .booked_customer_main_table_wrapper {
    padding: 16px;
  }

  .booked_customer_data_table_close_button {
    font-size: 0.9rem;
    padding: 8px 16px;
  }

  .booked_customer_data_table thead th,
  .booked_customer_data_table tbody td {
    font-size: 0.85rem;
    padding: 10px 12px;
  }

  .booked_customer_data_show_button {
    font-size: 0.8rem;
    padding: 6px 12px;
  }
}

@media (max-width: 480px) {
  .booked_customer_main_table_wrapper {
    padding: 12px;
  }

  .booked_customer_data_table_close_button {
    font-size: 0.8rem;
    padding: 6px 12px;
  }

  .booked_customer_data_table thead th,
  .booked_customer_data_table tbody td {
    font-size: 0.8rem;
    padding: 8px 10px;
  }

  .booked_customer_data_show_button {
    font-size: 0.75rem;
    padding: 5px 10px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/customer/Customer.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,2DAA2D;IAC3D,SAAS;IACT,aAAa;IACb,+BAA+B;IAC/B,mBAAmB;IACnB,+CAA+C;IAC/C,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,uBAAuB;IACvB,2DAA2D;IAC3D,yBAAyB;IACzB,mBAAmB;IACnB,gCAAgC;IAChC,yBAAyB;IACzB,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,YAAY;AAChB;AACA;EACE,2BAA2B;EAC3B;2CACyC;EACzC,qDAAqD;AACvD;;AAEA;EACE,SAAS;EACT,aAAa;EACb,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;IACI,cAAc;AAClB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,6BAA6B;AAC/B;;AAEA;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,aAAa;EACf;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,SAAS;IACT,aAAa;IACb,8BAA8B;EAChC;EACA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA,0BAA0B;;AAE1B;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,wCAAwC;EACxC,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,wCAAwC;AAC1C;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,mCAAmC;EACnC,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,yBAAyB;AAC3B;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,sCAAsC;AAC1C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;;IAEE,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;;IAEE,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;EACnB;AACF","sourcesContent":[".customer_residency_container {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));\n    gap: 25px;\n    padding: 25px;\n    /* background-color: #f9f9f9; */\n    border-radius: 12px;\n    /* box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1); */\n    margin-top: 50px;\n}\n\n.customer_residency_name {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: center;\n    /* background: linear-gradient(145deg, #f6ede7, #ffffff); */\n    border: 1px solid #d85200;\n    border-radius: 15px;\n    box-shadow: 2px 0 25px #d9baa740;\n    transition: all 0.3s ease;\n    cursor: pointer;\n    overflow: hidden;\n    height: 100px;\n    width: 300px;\n}\n.customer_residency_name:hover {\n  transform: translateY(-8px);\n  box-shadow: 6px 6px 12px rgba(0, 0, 0, 0.15),\n    -6px -6px 12px rgba(255, 255, 255, 0.9);\n  background: linear-gradient(145deg, #f9f9f9, #e9e9e9);\n}\n\n.customer_residency_name p {\n  margin: 0;\n  padding: 16px;\n  font-size: 1.1rem;\n  font-weight: 700;\n  color: #333;\n  text-align: center;\n  transition: color 0.3s ease;\n}\n\n.customer_residency_name:hover p {\n    color: #d85200;\n}\n\n.customer_residency_name .card-image {\n  width: 100%;\n  height: 140px;\n  background-size: cover;\n  background-position: center;\n  border-bottom: 1px solid #ddd;\n}\n\n@media (max-width: 768px) {\n  .customer_residency_name {\n    border-radius: 12px;\n  }\n\n  .customer_residency_name p {\n    font-size: 1rem;\n    padding: 14px;\n  }\n\n  .customer_residency_name .card-image {\n    height: 120px;\n  }\n}\n\n@media (max-width: 480px) {\n  .customer_residency_container {\n    gap: 20px;\n    padding: 15px;\n    grid-template-columns: 1fr 1fr;\n  }\n  .customer_residency_name .card-image {\n    height: 100px;\n  }\n\n  .customer_residency_name p {\n    font-size: 0.9rem;\n  }\n}\n\n/* booked cuatomer table */\n\n.booked_customer_main_table_wrapper {\n  padding: 20px;\n  background-color: #f9f9f9;\n  border-radius: 12px;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  max-width: 100%;\n  margin: 20px auto;\n  overflow-x: auto;\n}\n\n.booked_customer_data_table_close_button {\n  background-color: #f44336;\n  color: #fff;\n  border: none;\n  padding: 10px 20px;\n  font-size: 1rem;\n  font-weight: bold;\n  border-radius: 6px;\n  cursor: pointer;\n  margin-bottom: 20px;\n  transition: background-color 0.3s ease;\n}\n\n.booked_customer_data_table_close_button:hover {\n  background-color: #d32f2f;\n}\n\n.booked_customer_data_table {\n  width: 100%;\n  border-collapse: collapse;\n  background-color: #fff;\n  border-radius: 8px;\n  overflow: hidden;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.booked_customer_data_table thead {\n    background-color: #ffe6d7;\n    color: #d85200;\n}\n\n.booked_customer_data_table thead th {\n  padding: 12px 15px;\n  text-align: left;\n  font-size: 1rem;\n  border: 1px solid #fff;\n}\n\n.booked_customer_data_table tbody tr {\n  /* border-bottom: 1px solid #ddd; */\n  /* border: 1px solid #bbb8b8; */\n}\n\n.booked_customer_data_table tbody tr:hover {\n  background-color: #f1f1f1;\n}\n\n.booked_customer_data_table tbody td {\n  padding: 12px 15px;\n  font-size: 0.9rem;\n  color: #333;\n  border: 1px solid #bbb8b8;\n}\n\n.booked_customer_data_show_button {\n    background-color: #d85200;\n    color: #fff;\n    border: none;\n    padding: 8px 16px;\n    font-size: 0.9rem;\n    border-radius: 6px;\n    cursor: pointer;\n    transition: background-color 0.3s ease;\n}\n\n.booked_customer_data_show_button:hover {\n  background-color: #0056b3;\n}\n\n.booked_customer_data_not_found {\n  font-size: 1rem;\n  color: #666;\n  text-align: center;\n  margin-top: 20px;\n}\n\n@media (max-width: 768px) {\n  .booked_customer_main_table_wrapper {\n    padding: 16px;\n  }\n\n  .booked_customer_data_table_close_button {\n    font-size: 0.9rem;\n    padding: 8px 16px;\n  }\n\n  .booked_customer_data_table thead th,\n  .booked_customer_data_table tbody td {\n    font-size: 0.85rem;\n    padding: 10px 12px;\n  }\n\n  .booked_customer_data_show_button {\n    font-size: 0.8rem;\n    padding: 6px 12px;\n  }\n}\n\n@media (max-width: 480px) {\n  .booked_customer_main_table_wrapper {\n    padding: 12px;\n  }\n\n  .booked_customer_data_table_close_button {\n    font-size: 0.8rem;\n    padding: 6px 12px;\n  }\n\n  .booked_customer_data_table thead th,\n  .booked_customer_data_table tbody td {\n    font-size: 0.8rem;\n    padding: 8px 10px;\n  }\n\n  .booked_customer_data_show_button {\n    font-size: 0.75rem;\n    padding: 5px 10px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
